(ns motorsaif.malli
  (:require
   [malli.core :as m]
   [motorsaif.log :as log]
   [motorsaif.i18n :as i18n :refer [tr]]
   [clojure.string :as str]
   [malli.error :as me]
   [malli.transform :as mt]))

(def ^:private errors
  (-> me/default-errors

      (assoc :string
             {:error/fn {:en (fn [{:keys [schema value]} _]
                             (let [{:keys [min max]} (m/properties schema)]
                               (cond
                                 (not (string? value)) (tr :malli.string.not)
                                 (and min (= min max)) (tr [:malli.string.min-is-max] [max])
                                 (and min max) (tr [:malli.string.between] [min max])
                                 min (tr [:malli.string.min] [min])
                                 max (tr [:malli.string.max] [max]))))}})

      (assoc ::m/missing-key {:error/fn (fn [{:keys [path in schema] :as tezt} ab]
                                          (if (some #{:request/media} in)
                                            :require-images
                                            :missing-key))})))


(def ^:private transformer (mt/transformer mt/string-transformer
                                           mt/default-value-transformer
                                           mt/strip-extra-keys-transformer))


;; (validate zs zd)
(defn validate [schema data]
  ;; (def zs schema)
  ;; (def zd data)
  (let [decoded (m/decode schema data transformer)
        explain (m/explain schema decoded)
        [error-vals human] ((juxt me/error-value
                                  #(me/humanize % {:errors errors})) explain)
        ;; Get all top level errors so provide user an idea of what's wrong.
        error-paths (map :in (:errors explain))

            error-titles-fn (fn [form-key]
                          (let [ret (remove nil? (map
                                                  #(i18n/tr (concat [:validation form-key] %))
                                                  error-paths))]
                            (if (seq ret)
                              ret
                              ;; #?(:cljs
                              ;;    (rf/dispatch [:send-error])
                              ;;    )

                              (do (log/error [:human human
                                              :vals error-vals])
                                  nil)
                              ))
                          )]
    #_(log/debug [:data data
                  :explain explain])
    (if explain
      {:error-vals error-vals
       :error-titles-fn error-titles-fn
       :data explain
       :error-paths error-paths
       :valid false
       :human human}
      {:valid true
       :data data
       :decoded decoded})))

(defn check-or-throw [schema data]
  (let [{:keys [valid human]} (validate schema data)]
    (if valid
      true
      (throw
       (ex-info (str "Spec failed: \n " data)
                {:error human})))))
